export class RedshiftClusters {
    'clusters';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "clusters",
            "baseName": "clusters",
            "type": "Array<RedshiftCluster>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RedshiftClusters.attributeTypeMap;
    }
    constructor() {
    }
}
